// removed by extract-text-webpack-plugin
module.exports = {"slideLoader":"src-components-ui----SlideLoader-module---slideLoader---3-tYK","imgFrame":"src-components-ui----SlideLoader-module---imgFrame---LdhEH","slideWrap":"src-components-ui----SlideLoader-module---slideWrap---V4gUS","correctDistortionWrapper":"src-components-ui----SlideLoader-module---correctDistortionWrapper---1OyBx","loadContainer":"src-components-ui----SlideLoader-module---loadContainer---TdT6b","loadFrame":"src-components-ui----SlideLoader-module---loadFrame---7pJaF"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ui/SlideLoader.module.scss
// module id = 866
// module chunks = 114276838955818